module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/partials/right-sidebar/right-sidebar.component.scss
// module id = ./src/app/components/partials/right-sidebar/right-sidebar.component.scss
// module chunks = main